var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Body } from 'syf-component-library/ui/typography';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { useManageCardHolderModalContext } from '../../../context/manage-card-holder-modal-context';
import { Container, HeaderContainer, Label, MembershipNumberContainer, RadioGroupContainer, UserInfoContainer, UserNameContainer, UserRadioContainer } from './subcomponents';
import SamsSteps from '../SamsSteps';
import { translate } from '../../../strings/i18n';
var EligibleMemberList = function () {
    var _a;
    var _b = useManageCardHolderModalContext(), selectedSamsUser = _b.selectedSamsUser, eligibleMembers = _b.eligibleMembers, updateSelectedSamsUser = _b.updateSelectedSamsUser, updateIsAuthorizedUserSubmitted = _b.updateIsAuthorizedUserSubmitted;
    var selectedUser = (_a = selectedSamsUser.value) === null || _a === void 0 ? void 0 : _a.partnerId;
    useEffect(function () {
        updateSelectedSamsUser({
            touched: false,
            value: selectedUser ? selectedSamsUser.value : eligibleMembers[0],
            errorMessage: undefined
        });
        updateIsAuthorizedUserSubmitted(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var handleSelectUser = function (partnerId) {
        var selectedEligibleMember = eligibleMembers.filter(function (eligibleMember) { return eligibleMember.partnerId === partnerId; })[0];
        updateSelectedSamsUser({
            touched: false,
            value: selectedEligibleMember,
            errorMessage: undefined
        });
        updateIsAuthorizedUserSubmitted(false);
    };
    return (_jsxs(Container, { children: [_jsxs(HeaderContainer, __assign({ bottom: "small", left: "medium", right: "medium" }, { children: [_jsx(Body, __assign({ weight: "bold" }, { children: translate('addAuthUserScreen.nameLabel') })), _jsx(Body, __assign({ weight: "bold" }, { children: translate('addAuthUserScreen.membershipNumber') }))] })), _jsx(RadioGroupContainer, __assign({ selected: selectedUser, onChange: handleSelectUser }, { children: eligibleMembers.map(function (eligibleMember) {
                    var firstName = eligibleMember["cipher.firstName"], lastName = eligibleMember["cipher.lastName"], partnerId = eligibleMember.partnerId;
                    return (_jsx(UserRadioContainer, __assign({ id: partnerId, value: partnerId, name: "user-".concat(partnerId) }, { children: _jsxs(UserInfoContainer, { children: [_jsx(UserNameContainer, { children: "".concat(firstName, " ").concat(lastName) }), _jsx(Inset, __assign({ top: "xsmall", hideOnBreakpointUp: "small" }, { children: _jsxs(MembershipNumberContainer, { children: [_jsxs(Label, { children: [translate('addAuthUserScreen.membershipNumber'), ' '] }), partnerId] }) }))] }) }), partnerId));
                }) })), _jsx(SamsSteps, { title: translate('missingSomeone') })] }));
};
export default EligibleMemberList;
